import { useState } from "react";
import { Checkbox } from "@/components/ui/checkbox";

/** The requirements are the estimate's answer — only what is ticked shows here. */
export default function Requirements({ group, requirements, onSave, testId }) {
  const [editing, setEditing] = useState(false);
  const flags = (requirements.flags || []).filter((f) => f.group === group);
  const on = flags.filter((f) => f.value);
  return (
    <div data-testid={testId}>
      <div className="flex items-center justify-between">
        <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">
          Requirements
        </p>
        {requirements.editable && (
          <button onClick={() => setEditing((v) => !v)} data-testid={`${testId}-edit`}
                  className="text-[11px] font-medium text-blue-600 hover:underline">
            {editing ? "Done" : "Edit"}
          </button>
        )}
      </div>
      {editing ? (
        <div className="mt-2 flex flex-wrap gap-x-5 gap-y-1.5">
          {flags.map((f) => (
            <label key={f.key} className="flex items-center gap-2 text-sm">
              <Checkbox checked={f.value} data-testid={`ops-flag-${f.key}`}
                        onCheckedChange={(v) => onSave({ [f.key]: !!v })} />
              <span className="text-slate-700">{f.label}</span>
            </label>
          ))}
        </div>
      ) : (
        <div className="mt-2 flex flex-wrap gap-1.5">
          {on.length === 0 && (
            <span className="text-xs text-slate-400">Nothing selected</span>
          )}
          {on.map((f) => (
            <span key={f.key} data-testid={`ops-flag-chip-${f.key}`}
                  className="rounded-full border border-slate-200 bg-slate-50 px-2 py-0.5 text-xs font-medium text-slate-700">
              {f.label}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
